import FontPicker from 'react-fontpicker-ts';
import { jsx as _jsx } from "react/jsx-runtime";
// Extend the default list of allowed fonts
// that are not supported by the library
export const CUSTOM_FONTS = [{
  category: 'sans-serif',
  name: 'Geist',
  sane: 'geist',
  cased: 'Geist',
  variants: ['0,300', '0,400', '0,500', '0,600', '0,700']
}];

const FontsLoader = _ref => {
  let {
    loadFonts = []
  } = _ref;
  if (!loadFonts.length) return null;
  return /*#__PURE__*/_jsx(FontPicker, {
    loadFonts: loadFonts,
    loaderOnly: true,
    localFonts: CUSTOM_FONTS
  });
};

export default FontsLoader;